/**
 * @desc AJS compliant router function to handle migration routes
 * @param {angular.$stateProvider} $stateProvider - Angular stateprovider to handle states
 * @return {void}
 */
export function SeoRouter($stateProvider) {
  $stateProvider
    .state('app.seo_listing', {
      url: '/seo/listing',
      template: '<app-seo-list></app-seo-list>',
      data: {
        authorizedPermissions: ['EDITORIAL'],
      },
    })
    .state('app.seo_edit', {
      url: '/seo/edit/:countryId/:destinationId/:categoryId/:language',
      params: {
        categoryId: null,
        countryId: null,
        destinationId: null,
        language: null,
      },
      template: '<app-seo-edit></app-seo-edit>',
      data: {
        authorizedPermissions: ['EDITORIAL'],
      },
    });
}



// WEBPACK FOOTER //
// ./src/app/seo/seo.router.js